import { JwtAuthTokenService } from 'angular-jwt-auth';
import { MenuItem } from 'primeng/api';
import { AuthenticationRoute } from 'src/domains/authentication/authentication.route';
import { groupsRoute } from 'src/domains/authentication/feature/groups/groups.route';
import { LoginRequest } from 'src/domains/authentication/model/login-auth/login.request';
import { BlackListRoute } from 'src/domains/site-managment/app/feature/black-list/black-list.route';
import { FaqRoute } from 'src/domains/site-managment/app/feature/faq/faq.route';
import { logsRoute } from 'src/domains/site-managment/app/feature/logs/logs.route';
import { TermRoute } from 'src/domains/site-managment/app/feature/term/term.route';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';

export const menu: MenuItem[] = [
  {
    label: 'پیام ها',
    icon: 'isax icon-notification',
    routerLink: AuthenticationRoute.map.dashboard.notifications,
  },
  {
    label: ' اطلاعات حساب کاربری',
    icon: 'isax icon-user',
    routerLink: AuthenticationRoute.map.dashboard.authentication,
  },
  {
    label: 'سوابق ورود',
    icon: 'isax icon-login',
    routerLink: logsRoute.map.dashboard.login_history,
  },
  {
    label: 'مدیریت وبسایت',
    icon: 'isax icon-global',
    parent: true,
    items: [
      {
        label: 'صفحه اصلی',
        routerLink: SiteManagmentRoute.map.dashboard.edit_main_page,
      },
      {
        label: 'پیکربندی سیستم',
        routerLink: SiteManagmentRoute.map.dashboard.config_system,
      },
      {
        label: 'مدیریت پیام ها',
        routerLink:
          SiteManagmentRoute.map.dashboard.app_notification_panel_list,
      },
      {
        label: 'کاربران',
        routerLink: AuthenticationRoute.map.dashboard.user_managment,
      },
      {
        label: 'سازنده ها',
        routerLink: AuthenticationRoute.map.dashboard.company_list,
      },
      {
        label: 'سوالات متداول',
        routerLink: FaqRoute.map.dashboard.faqs_list,
      },
      {
        label: 'قوانین و مقررات',
        routerLink: TermRoute.map.dashboard.terms_list,
      },
      {
        label: 'گروه ها',
        routerLink: groupsRoute.map.dashboard.groups_list,
      },
      {
        label: 'درخواست های تماس با ما',
        routerLink: SiteManagmentRoute.map.dashboard.contact_requests,
      },
    ],
  },
  {
    label: 'امنیت',
    icon: 'isax icon-security-safe',
    parent: true,
    items: [
      {
        label: 'لیست سیاه',
        routerLink: BlackListRoute.map.dashboard.black_list,
      },
      {
        label: 'نشست‌های فعال کاربران',
        routerLink: SiteManagmentRoute.map.dashboard.admin_active_sessions,
      },
    ],
  },
  {
    label: 'گزارش ها',
    icon: 'isax icon-note',
    parent: true,
    items: [
      {
        label: 'لاگ سیستم',
        routerLink: logsRoute.map.dashboard.logs,
      },
    ],
  },
  {
    label: 'خروج',
    icon: 'isax icon-logout',
    command: () => {
      new LoginRequest.Delete(undefined).call().subscribe(async (data) => {
        if (data?.response?.statusCode === 200) {
          await JwtAuthTokenService.clearToken();
          location.href = '/';
        }
      });
    },
  },
];
